module.exports = __webpack_public_path__ + "img/2.7d20a00b.png";